<div class="tab-pane" role="tabpanel" id="tipocip">
        <fieldset id="agregar_tipocip" class="">
            <div class="step_section">
                <form [formGroup]="form">
                    <div class="row" id="row">
    
                        <div class="col-md-12" id="content">
                            <div class="alert alert-danger" role="alert" id="tp_find_alert" name="tp_find_alert" hidden>
                                <i class="fa fa-exclamation-triangle fa-2x" aria-hidden="true"></i>
                                <span id="tp_dir_message"></span>
                            </div>
                            <div class="form-horizontal">
                                <div class="form-group" align="left">
                                    <div class="col-sm-4">
                                        <label for="cambio_profesional">Adjunta comunicaci&oacute;n del propietario en que se señale el cambio de profesionales</label>
                                    </div>
                                    <div class="col-sm-3" align="left">
                                            <mat-radio-group formControlName="cambio_profesional" (change)="add_cambio_profesional()">
                                                <mat-radio-button style="padding-right: 20px" name="cambio_profesional" value="SI">SI</mat-radio-button>
                                                <mat-radio-button style="padding-right: 20px" name="cambio_profesional" value="NO">NO</mat-radio-button>
                                            </mat-radio-group>
                                    </div>
                                </div>
                            </div>
    
                        </div>
                    </div>
                </form>
            </div>
        </fieldset>
    </div>
    <div class="separator"></div>